/**
 * Centralized Pricing Configuration
 *
 * Single source of truth for all pricing displayed in the app.
 * Update this file when Stripe prices change.
 *
 * Last updated: December 2025
 */

export const PRICING = {
  // Starter Plan
  STARTER: {
    MONTHLY: 99,
    ANNUAL: 990,
    MONTHLY_EQUIVALENT_ANNUAL: 82.50, // $990/12
  },

  // Standard Plan
  STANDARD: {
    MONTHLY: 199,
    ANNUAL: 1990,
    MONTHLY_EQUIVALENT_ANNUAL: 165.83, // $1990/12
  },

  // Professional Plan
  PROFESSIONAL: {
    MONTHLY: 299,
    ANNUAL: 2990,
    MONTHLY_EQUIVALENT_ANNUAL: 249.17, // $2990/12
  },

  // Add-ons
  ADD_ONS: {
    ENVIRONMENT_MONTHLY: 99,
    ENVIRONMENT_ANNUAL: 990,
    WORKSPACE_MONTHLY: 149,
  },
} as const;

/**
 * Format price for display
 */
export function formatPrice(amount: number, showCents = false): string {
  if (showCents || amount % 1 !== 0) {
    return `$${amount.toFixed(2)}`;
  }
  return `$${amount.toLocaleString()}`;
}

/**
 * Get the default/recommended plan price for reactivation, upgrade CTAs, etc.
 */
export function getDefaultPlanPrice(): number {
  return PRICING.PROFESSIONAL.MONTHLY;
}

/**
 * Get annual savings percentage
 */
export function getAnnualSavings(plan: 'STARTER' | 'STANDARD' | 'PROFESSIONAL'): number {
  const monthly = PRICING[plan].MONTHLY * 12;
  const annual = PRICING[plan].ANNUAL;
  return Math.round((1 - annual / monthly) * 100);
}
